import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Grid, Tooltip } from "@material-ui/core";
import { Link } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";

const todate = new Date();
var fromdate = todate.getFullYear() - 1 + '/04/01';
//const fromdate = new Date().setFullYear(new Date().getFullYear(),0);
//const fromdate = new Date(new Date().setDate(new Date().getDate() - 30));

const SalesAnalysis = () => {

    const [Model, setModel] = useState('');
    const [Customer, setCustomer] = useState('');
    const [Industry, setIndustry] = useState('');
    const [Category1, setCategory1] = useState('');
    const [Category2, setCategory2] = useState('');
    const [Category3, setCategory3] = useState('');
    const [Category4, setCategory4] = useState('');
    const [Count, setCount] = useState('');
    const [SalesExecutiveID, setSalesExecutiveID] = useState('');
    const [ProductGroupID, setProductGroupID] = useState('');
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [ComboSalesExecutive, setComboSalesExecutive] = useState([]);
    const [ProductGroupIDcmb, setProductGroupIDcmb] = useState([]);
    const [CountryIDcmb, setCountryIDcmb] = useState([]);
    // const [ProductID, setProductID] = useState('');
    const [CountryID, setCountryID] = useState('');
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [SearchMode, setSearchMode] = useState("SEARCH");

    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    useEffect(() => {
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["cmbProductGroup"] !== undefined) {
                setProductGroupIDcmb(ComboDataResponse["cmbProductGroup"]);
            }
            if (ComboDataResponse["CountryAuto"] !== undefined) {
                setCountryIDcmb(ComboDataResponse["CountryAuto"]);

            }
            if (ComboDataResponse["SalesExecutive"] !== undefined) {
                setComboSalesExecutive(ComboDataResponse["SalesExecutive"]);

            }

        }
    }, [ComboDataResponse]);

    const GetComboData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", "");
        // bodyFormData.append("ProductCat1ID", "");
        // bodyFormData.append("ProductCat2ID", "");
        // bodyFormData.append("ProductCat3ID", "");
        fetchComboData("SalesAnalysis/ComboData", bodyFormData);
    };



    const PopulateData = () => {
        // debugger;
        var SalesTeamList = "";
        var bodyFormData = new FormData();
        bodyFormData.append("Model", Model);
        bodyFormData.append("Customer", Customer);
        bodyFormData.append("Industry", Industry);
        bodyFormData.append("Category1", Category1);
        bodyFormData.append("Category2", Category2);
        bodyFormData.append("Category3", Category3);
        bodyFormData.append("Category4", Category4);
        bodyFormData.append("SalesExecutiveID", SalesExecutiveID);
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        bodyFormData.append("ProductGroupID", ProductGroupID);
        bodyFormData.append("CountryID", CountryID);
        //bodyFormData.append("Description", Description);
        fetchData("SalesAnalysis/ListSalesAnalysis", bodyFormData);
    };

    useEffect(() => {
        const gridCols = [
            /* {
                field: "id",
                headerName: ".",
                renderCell: (params) => (<strong> <Link to={{ pathname: "/SalesAnalysis/SalesAnalysisView", state: { DeliveryChallanID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            }, */
            {
                field: "InvoiceNo",
                headerName: "Invoice No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "InvoiceDate",
                headerName: "Invoice Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 165,
            },
            {
                field: "AccountName",
                headerName: "Customer",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,

            },
            {
                field: "ModelCode",
                headerName: "ModelCode",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "ProductName",
                headerName: "Product",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "ProductCat1",
                headerName: "ProductCat1",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,

            },
            {
                field: "Description",
                headerName: "Model Description",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
                renderCell: (params) => (
                    <Tooltip title={params.row.Description} >
                        <span className="table-cell-trucate">{params.row.Description}</span>
                    </Tooltip>
                ),
            },
            {
                field: "Quantity",
                headerName: "Qty",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 110,
            },
            {
                field: "Rate",
                headerName: "Rate",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 120,
            },
            {
                field: "RateINR",
                headerName: "Rate in INR",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "Country",
                headerName: "Country",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Country",
                headerName: "Country",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Industry",
                headerName: "Industry",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "UserName",
                headerName: "SalesExe",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
        ];
        setColumns(gridCols);
        // debugger;
        setRows(response);
        setCount(response.length);
    }, [response]);

    useEffect(() => {
        GetComboData();
        PopulateData();
    }, []);

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['InvoiceNo', 'InvoiceDate', 'ContactName', 'ModelCode', 'Description', 'Unit', 'Quantity', 'Rate', 'Currency', 'ConvFactor', 'RateINR', 'Amount']
                }} />
            </GridToolbarContainer>
        );
    }

    return <div >
        <Grid container direction="row" >
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <div style={{ width: "198px", marginLeft: 6 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    />
                </div>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <div style={{ width: "198px", marginLeft: 7 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onToClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    />
                </div>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Input
                    label="Customer"
                    id="Customer"
                    onChange={(e) => setCustomer(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Input
                    label="Industry"
                    id="Industry"
                    onChange={(e) => setIndustry(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Input
                    label="Model(s)"
                    id="Model"
                    onChange={(e) => setModel(e.target.value)}
                />
            </Grid>
        </Grid>
        <Grid container direction="row" style={{ marginTop: 7 }} >
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Product Group"
                    id="Product"
                    options={ProductGroupIDcmb}
                    //onChange={onSelectChange}
                    onChange={(e) => setProductGroupID(e.target.value)}
                />
            </Grid>

            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Input
                    label="Category 1"
                    id="Category1"
                    onChange={(e) => setCategory1(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Country"
                    id="Country"
                    options={CountryIDcmb}
                    //onChange={onSelectChange}
                    onChange={(e) => setCountryID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Sales ExecutiveID"
                    id="SalesExecutiveID"
                    options={ComboSalesExecutive}
                    onChange={(e) => setSalesExecutiveID(e.target.value)}
                />
            </Grid>
            <label style={{ fontWeight: 'bold', width: 30, marginTop: 15 }}>{Count}</label>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Button
                    text="Populate"
                    startIcon={<SearchIcon />}
                    onClick={() => {
                        PopulateData();
                    }}
                />
            </Grid>
            {/* <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Input
                    label="Category 2"
                    id="Category2"
                    onChange={(e) => setCategory2(e.target.value)}
                />
            </Grid> */}
        </Grid>
        <Grid container direction="row" >
            {/* <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Input
                    label="Category 3"
                    id="Category3"
                    onChange={(e) => setCategory3(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Input
                    label="Category 4"
                    id="Category4"
                    onChange={(e) => setCategory4(e.target.value)}
                />
            </Grid> */}

        </Grid>
        <BiztranControls.DataGrid
            headerHeight={34}
            rowHeight={25}
            rows={rows}
            columns={columns}
            checkboxSelection={false}
            // autoHeight={true}
            //Height="2610px"
            Height="400px"
            Width="100%"
            components={{ Toolbar: CustomToolbar, }}
        />
    </div>
};

export default SalesAnalysis;